import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AlertConfigurationRoutingModule } from './alert-configuration-routing.module';
import { AlertConfigurationComponent } from './alert-configuration/alert-configuration.component';
import { AlertCardModule } from 'libs/portal/src/modules/keepalive/components/alert-card/alert-card.module';
import { MatColComponent } from 'libs/portal/src/modules/tools/mat-col/mat-col.component';
import { MatRowComponent } from 'libs/portal/src/modules/tools/mat-row/mat-row.component';

@NgModule({
  declarations: [AlertConfigurationComponent],
  imports: [CommonModule, AlertConfigurationRoutingModule, AlertCardModule, MatRowComponent, MatColComponent, MatRowComponent],
  exports: [AlertConfigurationComponent],
})
export class AlertConfigurationModule {}
